import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Logo from '../images/Logo_with tagline.png';
import MobileMenuIcon from '../images/mobile-menu.png';
import Favicon from "../images/favicon.png";
import Nav from './Nav';
import Link from 'gatsby-link';
import PropTypes from 'prop-types'; // ES6
import classNames from 'classnames';
import { Helmet } from 'react-helmet';


class Header extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isNavHidden: true,
            hasShadow: false,
        }

        this.toggleNav = this.toggleNav.bind(this);
        document.addEventListener('scroll', (event) => {
            var doc = document.documentElement;
            var left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
            var top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
            this.setState({
                hasShadow: top > 10
            });
        })
    }

    toggleNav() {
        this.setState({
            isNavHidden: !this.state.isNavHidden
        })
    }
    render() {
        let headerClasses = classNames({
            'has-parky': ['/', '/#'].indexOf(this.props.location.pathname) !== -1,
            'has-shadow': this.state.hasShadow
        });
        return (
            <header id="header" className={headerClasses}>
                <Helmet>
                    <link rel="shortcut icon" href={Favicon} type="image/png"/>
                  </Helmet>
                <div className="mobile-menu">
                    <div className="mobile-menu-icon cursor" onClick={this.toggleNav}>
                            <img id="menu" className={`${this.state.isNavHidden === true ? 'open' : ''}`} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC6SURBVGhD7dghioJxEEDxD8SwRxAEwSsIXsEuCG7yAApGsRn2JBqMJg8gGO2GPYRFDJb1fX38m5RZeA9+cfIMU5mZmZnlr4EJFonN0UaxH/z9A78otkY0mM0VTTytgx1OiR0whJmZ2dvqo17/0TbN4oIlim0RDWdzR/FEmSEazKY+U17WwyixAb5gZmb5qt9B34jeMFlM0UKxFaJNms0ZxTaIBrO5oXhrdbFH9IbJ4ogxzMzMzOwjVdUDQg2cr1ZElkQAAAAASUVORK5CYII="/>
                            <img id="close" className={`${this.state.isNavHidden === true ? '' : 'open'}`} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHYSURBVGhD7dfdSpRRGIbhsbQziEzLStvqIMQkLNCQtJAQiUBFPQ6329dIIiJEJTqY1AzRSvAIKu1PvR91wcvHcnScXLOE94YL9HN+1sOozJQ8z/M8z/O8LHuMJwdfVl0dJnF7/7uEacQf/MWALlSRRkxhFxtoQ5LCCD2xaMxTnCaNmEZ4LPmGWzjz9Otkh4jGDKKSNOIl7OPIV7QiSXpVfsMeoJIxF/AK9v6iEUleDVs/fsEeRGOGUK6LmIG9n3xB8hGhPsTGPEOsciNuoqY9QmzMc9g04jXs7WQdNR8R6kVxzD+EMRrxBvbnktWI0EPExozgrbkWaMQNZFk3imNi1pDtiNBxYzSiBeeiHsRGbOLcjNAf9jvEhuxgGNlXbkSQ/RiNmEXx4HrbsV24pjH6b5Zd9ZiDPays4joeYOvwWqAxo8imBszDHlLCiNB9/IS9TTZjjhrxGddQrAuxMWOoWZewAHsoWUEzjkpjfsDep2ZjNOI97GFEI5pwXPcQGzOOZGnEB9hDyCecZESoE7ExE0jSC9gnl2VcRaV1IDbmLs68y/iI8MRLaMRpK47RR2B9nk9SGLOIK7pQZe34Dn161Of5pGnM/xgRugO9O/A8z/M8z/OyqlTaA3mN7FdoPXLZAAAAAElFTkSuQmCC" />
                    </div>
                    <Nav isNavHidden={this.state.isNavHidden} handleClick={this.toggleNav}/>
                </div>
                <div className="logo">
                    <Link to="/">
                        <img 
                            alt="ParkYou! Or go park yourself logo. Tagline for ParkYou!, a mobile platform to help city drivers instantaneously find street parking spots."
                            src={Logo} 
                        />
                        </Link>
                </div>
            </header>
        )
    }
}

Header.propTypes = {
    onOpenArticle: PropTypes.func,
    timeout: PropTypes.bool
}

export default connect()(withRouter(Header));



// WEBPACK FOOTER //
// ./src/components/Header.js